module.exports = __webpack_public_path__ + "static/media/Mountain.755c72db.glb";